import { RawDraftContentState } from "draft-js";

export default function getDescription(data: any): RawDraftContentState {
  if (data && "descriptionJson" in data) {
    const descriptionJsonToObj =
      data?.descriptionJson && JSON.parse(data?.descriptionJson);

    // Run JSON.parse again if type is string, to convert description from non-escaped string to object
    return typeof descriptionJsonToObj === "string"
      ? (JSON.parse(descriptionJsonToObj) as RawDraftContentState)
      : descriptionJsonToObj;
  } else {
    throw new Error(
      `Invalid argument type. "data" should have a "descriptionJson" property.`
    );
  }
}
